import { parse, isBefore, isSameDay, isAfter } from 'date-fns';

import { IKnmErknmFormEvent } from '../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { IKnmErknmFormSuspensionEvent } from '../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSuspensionEvent';

interface IReturnInterface {
  isValidStartDate: boolean;
  isValidStopDate: boolean;
}

const defaultValidValue = {
  isValidStartDate: true,
  isValidStopDate: true,
} as IReturnInterface;

/*
    проверки пересечения дат
    берем в валидацию только те приостановки у которых !(suspension.start>=action.start && suspension.end <= action.end))
    то есть приостановки у которых даты начала и даты окончания не находятся внутри действия (одновременно)
    пока работает только для ПМ
    возвращает true если приостановки не находятся внутри выбранного периода действия
   */
export const checkIntersectionValidateForSuspensionEvents = ({
  item,
  suspensionEventsForActEvent,
}: {
  item: IKnmErknmFormEvent;
  suspensionEventsForActEvent?: IKnmErknmFormSuspensionEvent[];
}): IReturnInterface => {
  if (!item.startDate || !item.stopDate) {
    return defaultValidValue;
  }

  const eventStartDate = parse(item.startDate, 'dd.MM.yyyy', new Date());
  const eventStopDate = parse(item.stopDate, 'dd.MM.yyyy', new Date());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let minDate: any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let maxDate: any;

  suspensionEventsForActEvent?.forEach(el => {
    const currentStartDate = parse(el.startDate as string, 'dd.MM.yyyy', new Date());

    if (!minDate || isBefore(currentStartDate, minDate)) {
      minDate = currentStartDate;
    }

    const currentStopDate = parse(el.stopDate as string, 'dd.MM.yyyy', new Date());

    if (!maxDate || isAfter(currentStopDate, maxDate)) {
      maxDate = currentStopDate;
    }
  });

  if (!minDate || !maxDate) {
    return defaultValidValue;
  }

  return {
    isValidStartDate: isBefore(eventStartDate, minDate) || isSameDay(eventStartDate, minDate),
    isValidStopDate: isAfter(eventStopDate, maxDate) || isSameDay(eventStopDate, maxDate),
  };
};
